import React from "react"
import Button from "../../../shared/components/buttons/Button"
import { IUser } from "../../user/state/userTypes"
import { useDispatch } from "react-redux"
import { StyleVariants } from "../../../shared/state/sharedTypes"
import { useTranslation } from "react-i18next"
import API from "../../../apis/contextmeeting/api"
import { withAuthHeader } from "../../../apis/contextmeeting/withAuthHeader"
import { displayUserMessageAction } from "../../userMessage/state/userMessageActions"
import { UserMessageTypes } from "../../userMessage/state/userMessageTypes"

interface IPropsFromParent {
  user: IUser
}

const ResendInviteButton: React.FC<IPropsFromParent> = (props: IPropsFromParent): JSX.Element => {
  const { t } = useTranslation(["user"])
  const dispatch = useDispatch()
  const resendInvite = () => {
    API.post(`/users/${props.user.id}/resend_invite`, props.user, withAuthHeader()).then(() => {
      dispatch(displayUserMessageAction({
        messageKey: "resendInviteSuccess",
        type: UserMessageTypes.SUCCESS
      }))
    }).catch(() => {
      dispatch(displayUserMessageAction({
        messageKey: "resendInviteFail",
        type: UserMessageTypes.ERROR
      }))
    })
  }
  return (
    <Button variant={StyleVariants.ORANGE} action={() => resendInvite()}>
      {t("user:admin:buttons:resendInvite")}
    </Button>
  )
}

export default ResendInviteButton
